import { useState } from "react";
import Table from "../components/Table";
import Button from "../components/Button";
import Input from "../components/Input";
import { usHttp2 } from "../custom-hooks/use-http";
import appvariables from "../appvariables";
import React from "react";

const BillsForDate = () => {
    const [date, setDate] = useState("");
    const [bills, setBills] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleDateChange = (e) => {
        setDate(e.target.value);
    };

    const fetchBills = () => {
        setLoading(true);
        setError("");
        usHttp2(appvariables.apiurl + "bill/getbillsfordate/", "POST", { date })
            .then((response) => response.json())
            .then((json) => {
                if (json.status === "Success") {
                    setBills(json.bills);
                } else {
                    setError(json.message || "Error fetching bills");
                }
                setLoading(false);
            })
            .catch((err) => {
                setError("Network error");
                setLoading(false);
            });
    };

    const BillTypee = (billid) => {
      if (billid.includes("CRPY")) {
        return (
          <div
            style={{
              background: "#00c92b",
              padding: "2px 5px",
              borderRadius: "3px",
            }}
          >
            Credit Payment
          </div>
        );
      } else if (billid.includes("CASH")) {
        return (
          <div
            style={{
              background: "#ffeb3b",
              padding: "2px 5px",
              borderRadius: "3px",
            }}
          >
            Cash/Old Credit
          </div>
        );
      } else {
        return <div>Bill</div>;
      }
    };

    const TranformBillDate = (date) => {
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      return (
        // date.substring(8, 10) +
        // "," +
        // monthNames[Number(date.substring(5, 7)) - 1].substring(0, 3) +
        // "," +
        // date.substring(0, 4) +
        // `(${date.substring(11, 16)})`
        date.substring(11, 16)

      );
    };

    const tablefields = [
        { name: "Type", key: "billid", cs: { width: "40px" }, transformer: BillTypee },
        { name: "By", key: "billedby", cs: { width: "50px" }, filter: 1 },
        { name: "Customer", key: "customer", cs: { width: "150px" }, filter: 1 },
        { name: "Date (Time)", key: "createddatetimestamp", cs: { width: "130px" }, transformer: TranformBillDate },
        { name: "Products", key: "products", filter: 1, cs: { width: "300px" } },
        { name: "MRP", key: "totalfrommrp", cs: { width: "70px" } },
        { name: "Decided", key: "totalfinaldecided", cs: { width: "70px" } },
        { name: "Recieved", key: "totalrecieved", cs: { width: "70px" }, summary: 1 },
        { name: "Credit Amt", key: "creditamount", cs: { width: "80px" } }
        ];

    // Calculate min and max date for input
    const minDate = "2023-07-15";
    const maxDate = new Date().toISOString().slice(0, 10);

    return (
        <div style={{ maxWidth: 900, margin: "0 auto", padding: 20 }}>
            <h2>Bills for a Date</h2>
            <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 20 }}>
                <Input
                    type="date"
                    name="date"
                    displayname="Select Date"
                    inputboxstyle="normal"
                    value={date}
                    changehandler={handleDateChange}
                    min={minDate}
                    max={maxDate}
                />
                <Button clickhandler={fetchBills} disabled={!date || loading} cs={{ padding: "5px 15px" }}>
                    {loading ? "Loading..." : "Get Bills"}
                </Button>
            </div>
            {error && <div style={{ color: "red", marginBottom: 10 }}>{error}</div>}
            {bills.length > 0 && (
                <Table
                    data={bills}
                    tablefields={tablefields}
                    decider={"credit"}
                    summary={true}
                    rowstyling={{ backgroundColor: "rgb(255 73 73)" }}
                />
            )}
        </div>
    );
};

export default BillsForDate;
